import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

@Component({
  selector: 'gorusme-notu-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
      <div class="ui text-center fluid pb-2">
      <div class="ui primary label mini"> Görüşme Notu </div>
    </div>
    <div class="gc gc--gorusme" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">GÖRÜŞME NOTU</div>
        <div class="gn-konu gc-baslik-ana">{{ p()?.konu || 'Konu' }}</div>
        <div class="gn-alt">
          @if (p()?.gorusenKisi) { <span class="gn-kisi">{{ p().gorusenKisi }}</span> }
          @if (p()?.sonuc) { <span class="gn-sonuc">{{ p().sonuc }}</span> }
        </div>
        @if (p()?.sonrakiAdim) { <div class="gn-adim">{{ p().sonrakiAdim }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 60 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #0d9488; --accent-rgb: 13,148,136; }
    .gn-konu { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .gn-alt { display: flex; align-items: center; gap: 8px; margin-top: 2px; flex-wrap: wrap; }
    .gn-kisi { font-size: 11px; font-weight: 600; color: #5eead4; }
    .gn-sonuc { font-size: 10px; color: var(--py-metin-ikincil, #64748b); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .gn-adim { font-size: 9px; font-weight: 500; color: #fbbf24; padding: 2px 6px; border-radius: 2px; background: rgba(251,191,36,0.1); margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  `],
})
export class GorusmeNotuKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
}
